import { Component, OnInit } from '@angular/core';
import { MasterDataService } from '../../services/master-data.service';
import { NgModel } from '@angular/forms';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as moment from 'moment';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { BranchFilterService } from 'src/app/services/branch-filter.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-article-availability-report',
  templateUrl: './article-availability-report.component.html',
  styleUrls: ['./article-availability-report.component.css']
})
export class ArticleAvailabilityReportComponent implements OnInit {
  selectedBranch;
  branchList;
  partnerList;
  selectedPartner;
  isBranchSelected = false;
  isPartnerSelected = false;
  articleAvailabilityReport;
  showExportToExcelButton: Boolean;
  userRole;
  accessResponse: any;

  constructor(private masterDataService: MasterDataService,
    private commonMessageService: CommonMessageService, private branchFilterService: BranchFilterService) { }

  ngOnInit(): void {
    this.loadInitialDetails();
  }

  loadInitialDetails() {
    // this.masterDataService.getBranch().subscribe((res) => {
    //   this.branchList = res;
    // });
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.masterDataService.getBranch().subscribe((res) => {
      const branches = res as any[];
      const userBranchId = Number(localStorage.getItem('branchId'));

      this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
    });
  }

  selectAllBranch(select: NgModel, values) {
    this.selectAll(select, values, this.isBranchSelected, false);
    this.isBranchSelected = !this.isBranchSelected;
    this.getPartnerByBranch();
  }

  selectAllPartner(select: NgModel, values) {
    this.selectAll(select, values, this.isBranchSelected, false);
    this.isBranchSelected = !this.isBranchSelected;
  }
  selectAll(select: NgModel, values, isSelected, isId) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }

  getPartnerByBranch() {
    this.partnerList = [];
    var branchId = this.selectedBranch.map(({ id }) => id);
    if (branchId.length > 0) {
      this.masterDataService.getPartnersByBranch(branchId).subscribe((res: any) => {
        console.log('partner list', res);
        this.partnerList = res;
      });
    }
  }

  partnerId;
  onViewReport() {
    if (this.selectedBranch == null ||
      this.selectedBranch.length === 0 ||
      this.selectedPartner == null ||
      this.selectedPartner.length === 0
    ) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please choose all the values');
      return;
    }
    this.partnerId = this.selectedPartner.map(({ id }) => id);
    this.masterDataService.getArticleAvailabilityReport(this.partnerId).subscribe((res: any) => {
      console.log('article availability report', res);
      this.articleAvailabilityReport = res;
      if (this.articleAvailabilityReport == null) {
        this.commonMessageService.swalAlertWithoutIcon('', "No Record Found.");
        this.showExportToExcelButton = false;
      } else {
        this.showExportToExcelButton = true;
      }
    });
  }

  getTotalAvailableArticle(data) {
    var totalArticleCount = 0;
    data.details.map((res: any) => {
      totalArticleCount += res.availableArticles;
    });
    return totalArticleCount;
  }

  exportToExcelForArticleAvailabilityReport() {
    this.masterDataService.getArticleAvailabilityReportExcel(this.partnerId).subscribe((resp: any) => {
      const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "ArticleAvailabilityReport.xlsx";
      link.click();
    });
  }

  exportToPDFClick() {
    var docDefinition = {
      info: { title: 'Article Availability Report' },
      pageOrientation: 'landscape',
      content: [
      ],
    };

    docDefinition.content.push({ text: 'P G BHAGWAT LLP, Chartered Accountants', fontSize: 14, bold: true, alignment: 'center' });
    docDefinition.content.push({ text: 'Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045', alignment: 'center' });
    docDefinition.content.push({ text: 'Article Availability', fontSize: 14, bold: true, alignment: 'center', margin: [0, 10, 0, 5] });

    for (let i = 0; i < this.articleAvailabilityReport.length; i++) {
      var totalAvailableArticle = 0;
      this.articleAvailabilityReport[i].details.map(res => {
        totalAvailableArticle += res.availableArticles;
      });
      docDefinition.content.push(' ');
      docDefinition.content.push({ columns: [{ text: `Reporting Partner:${this.articleAvailabilityReport[i].firstName} ${this.articleAvailabilityReport[i].lastName}`, fontSize: 12, bold: true, margin: [0, 0, 0, 5] }, { text: `Branch:${this.articleAvailabilityReport[i].branch}`, fontSize: 12, bold: true, margin: [100, 0, 0, 5] }] });

      // docDefinition.content.push([{ text: `Reporting Partner:${this.articleAvailabilityReport[i].firstName} ${this.articleAvailabilityReport[i].lastName}`, fontSize: 12, bold: true, margin: [0, 0, 0, 5] }, { text: `Reporting Partner:${this.articleAvailabilityReport[i].firstName} ${this.articleAvailabilityReport[i].lastName}`, fontSize: 12, bold: true, margin: [0, 0, 0, 5] }])
      docDefinition.content.push({
        table: {
          headerRows: 1,
          widths: [200, '*', '*', '*', 200, '*'],
          body: [
            [{ text: 'Article Name', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
            { text: 'Leave From Date', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
            { text: 'Leave To Date', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
            { text: 'Articleship End Date', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
            { text: 'Reporting Manager', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] },
            { text: 'Available Articles', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] }],
            ...this.articleAvailabilityReport[i].details.map(res => [{ text: `${res.firstName} ${res.middleName} ${res.lastName}` }, { text: `${(res.fromDate == null ? 'Available' : moment(res.fromDate).format('DD-MM-YYYY'))}` }, { text: `${(res.toDate == null ? 'Available' : moment(res.toDate).format('DD-MM-YYYY'))}` }, { text: `${moment(res.articleEndDate).format('DD-MM-YYYY')}` }, { text: `${res.mgrFirstName} ${res.mgrMiddleName} ${res.mgrLastName}` }, { text: res.availableArticles }]),
            [{ text: 'Total Available Articles', bold: true, fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: `${totalAvailableArticle}`, fillColor: '#e1f4f7' }]
          ]
        }
      }
      );
    }
    pdfMake.createPdf(docDefinition).download('ArticleAvailability.pdf');
  }
}
